export default "__VITE_ASSET__7eb0bdd7__"